import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ManualSenha } from '../../interfaces/manual-senha';

@Injectable({ providedIn: 'root' })
export class ManualCallService {
  private apiURL = `${environment.apiUrl}/v${environment.apiVersion}/manual-call`;

  constructor(private httpClient: HttpClient) {}

  async listarResultado(clinicId: number): Promise<ManualSenha[]> {
    const response = await firstValueFrom(
      this.httpClient.get<any>(`${this.apiURL}/${clinicId}`)
    );
    return response?.data ?? [];
  }

  async pincar(payload: {
    clinicId: number;
    nrSeqPacSenhaFila: number;
    nmUsuario: string;
    dsLocal: string;
  }): Promise<any> {
    return await firstValueFrom(
      this.httpClient.post<any>(`${this.apiURL}/pincar`, payload)
    );
  }

  async priorizar(payload: {
    clinicId: number;
    nrSeqPacSenhaFila: number;
    modo: 'P' | 'G';
    dsLocal: string;
    nmUsuario: string;
    callerUsername: string;
  }): Promise<any> {
    return await firstValueFrom(
      this.httpClient.post<any>(`${this.apiURL}/pincar`, payload)
    );
  }

  async cancelar(payload: {
    clinicId: number;
    nrSeqPacSenhaFila: number;
    nmUsuario: string;
    dsLocal: string;
  }): Promise<any> {
    return await firstValueFrom(
      this.httpClient.post<any>(`${this.apiURL}/cancelar`, payload)
    );
  }
}
